import { BLOKKENDOOS_VERSION } from "site-config/src";

export const getReleaseName = (
  projectName: string | undefined,
  environment: string | undefined,
  ciCommitRefSlug?: string | undefined,
): string => {
  const packageVersion = BLOKKENDOOS_VERSION;

  if (!projectName) console.warn("Invalid getReleaseName: No projectName.");

  // Optional branch slug is only available after gitlab build
  const CI_SLUG = ciCommitRefSlug || process.env.CI_COMMIT_REF_SLUG;

  const buildId =
    environment && CI_SLUG ? `${CI_SLUG}:${environment}` : "localhost";

  const releaseName = `${projectName}:${packageVersion} - ${buildId}`;

  return releaseName;
};
